export default __webpack_public_path__ + "static/proptech-cfefc8f16168b378b5a263517ae313a8.png";